module.exports = __webpack_public_path__ + "img/factory.3c70c581.svg";